export const EMPTY_MESSAGES = {
    webhooks: [
        "No hooks in the water yet.",
        "Your systems are waiting to be connected.",
        "Every automation starts with a single webhook.",
        "The silence before the first event fires.",
        "Ready to bridge your apps?",
        "Nothing listening here — yet.",
        "Add a webhook and let the events flow.",
        "Time to connect the dots.",
        "Your integrations are patiently waiting.",
        "No outbound calls configured.",
        "The pipeline is quiet on this end.",
        "Zero webhooks, infinite possibilities.",
    ],
    parts: [
        "The parts bin is empty.",
        "Nothing on the shelf yet.",
        "Every product begins as a part.",
        "Your bill of materials awaits.",
        "The assembly line is standing by.",
        "No components catalogued yet.",
        "Add a part and start building.",
        "Zero parts in inventory.",
        "No raw materials on record.",
        "What are you making? Add your first part.",
    ],
    cycles: [
        "No cycles on the floor yet.",
        "The production line is idle.",
        "Machines are standing by.",
        "No runs scheduled or recorded.",
        "The floor is quiet for now.",
        "Production starts with a cycle.",
        "No manufacturing cycles defined.",
        "Ready when you are — add a cycle.",
        "Nothing has run through here yet.",
        "Define a cycle to start tracking output.",
    ],
    shifts: [
        "No shifts scheduled.",
        "The floor is unscheduled.",
        "No teams on the clock yet.",
        "The schedule is blank — time to fill it.",
        "Who's on the floor? Define your shifts.",
        "No working hours defined.",
        "No shift patterns configured.",
        "Staff your floor — add a shift.",
        "Nobody clocked in yet.",
        "A well-run plant starts with a shift.",
    ],
    zones: [
        "No zones mapped yet.",
        "The floor plan is blank.",
        "Your plant layout starts here.",
        "No production zones configured.",
        "Map your space to manage it better.",
        "The floor is undivided.",
        "No areas demarcated yet.",
        "Define zones to organise your operations.",
        "Every great plant starts with a map.",
        "Zone in — define your first area.",
    ],
    jobSchedules: [
        "No jobs on the schedule.",
        "Nothing queued for production.",
        "The work order queue is empty.",
        "Ready to plan — add a job.",
        "No production runs scheduled.",
        "The schedule board is clear.",
        "Queue up your first job to get started.",
        "No production slots allocated.",
        "Idle capacity waiting to be filled.",
        "Plan your first run and get things moving.",
    ],
    maintenanceSchedules: [
        "No maintenance scheduled.",
        "The maintenance calendar is clear.",
        "Machines don't last forever — schedule upkeep.",
        "No preventive tasks configured.",
        "No service intervals defined.",
        "Proactive maintenance starts here.",
        "No upkeep plans on file.",
        "Keep machines running — add a schedule.",
        "An ounce of prevention...",
        "Nothing booked for the workshop yet.",
    ],
    favReports: [
        "No favorites saved yet.",
        "Star a report to find it here fast.",
        "Your report shortcuts are empty.",
        "Curate your dashboard — save a report.",
        "No bookmarked reports yet.",
        "Favorites make the data come faster.",
        "Nothing starred yet.",
        "Pin your go-to reports for quick access.",
        "The shortcut drawer is empty.",
        "Find a report you love and star it.",
    ],
    deviceProfiles: [
        "No device profiles configured.",
        "Profiles are the DNA of your devices.",
        "No templates on file yet.",
        "Define a profile to standardise devices.",
        "Your device library is empty.",
        "No blueprints on file.",
        "Create a profile before adding devices.",
        "No device templates configured.",
        "Standardise your hardware — add a profile.",
        "Profiles make devices consistent.",
    ],
    devices: [
        "No devices bound to this plant.",
        "The sensor network is offline.",
        "No hardware connected yet.",
        "Nothing listening on the floor.",
        "No machines reporting in.",
        "Your IoT fleet is empty.",
        "Connect a device to see it come alive.",
        "Bind a device and start collecting data.",
        "Quiet on the wire.",
        "No telemetry coming in yet.",
    ],
    users: [
        "Nobody here but us.",
        "Invite your team to get started.",
        "A plant runs on people — add your team.",
        "No accounts configured yet.",
        "The user list is empty.",
        "No team members onboarded yet.",
        "Who's running this plant? Add some users.",
        "Great work starts with great people.",
        "Build your team — add the first member.",
        "Empty roster — let's change that.",
    ],
    roles: [
        "No roles defined.",
        "Access control starts here.",
        "Define roles to control who does what.",
        "No permission sets configured.",
        "Roles keep the right people in the right places.",
        "No access policies set up.",
        "Grant the right access — create a role.",
        "No groups configured yet.",
        "Secure your plant — define a role.",
        "Every team needs structure. Start with a role.",
    ],
    settings: [
        "No settings configured.",
        "Nothing to configure here yet.",
        "The configuration slate is clean.",
        "All quiet on the settings front.",
    ],
};
